/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Comparison_Noageratingsfound3Inputs */

const id_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada peringkat usia ditemukan`)
};

const ms_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada penarafan umur ditemui`)
};

const da_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen aldersvurderinger fundet`)
};

const de_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Altersfreigaben gefunden`)
};

const en_us2_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No age ratings found`)
};

const es_es2_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron clasificaciones por edad`)
};

const es_mx2_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron clasificaciones por edad`)
};

const fil_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang rating ng edad`)
};

const fr_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune classification trouvée`)
};

const it_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna classificazione età trovata`)
};

const hu_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található korhatár besorolás`)
};

const nl_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen leeftijdsclassificaties gevonden`)
};

const no_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen aldersvurderinger funnet`)
};

const pl_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono klasyfikacji wiekowych`)
};

const pt_br2_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No age ratings found`)
};

const pt_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma classificação etária encontrada`)
};

const ro_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit clasificări de vârstă`)
};

const fi_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikärajoja ei löytynyt`)
};

const sv_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga åldersklassificeringar hittades`)
};

const vi_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy xếp hạng độ tuổi`)
};

const tr_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaş sınırı bulunamadı`)
};

const cs_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenalezeno žádné věkové hodnocení`)
};

const bg_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени възрастови ограничения`)
};

const ru_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возрастные рейтинги не найдены`)
};

const uk_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вікових рейтингів не знайдено`)
};

const ar_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على تصنيفات عمرية`)
};

const hi_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई आयु रेटिंग नहीं मिली`)
};

const th_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบเรตอายุ`)
};

const ja_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年齢レーティングが見つかりません`)
};

const zh_cn2_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No age ratings found`)
};

const zh_hant1_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No age ratings found`)
};

const ko_components_comparison_noageratingsfound3 = /** @type {(inputs: Components_Comparison_Noageratingsfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No age ratings found`)
};

/**
* | output |
* | --- |
* | "No age ratings found" |
*
* @param {Components_Comparison_Noageratingsfound3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_comparison_noageratingsfound3 = /** @type {((inputs?: Components_Comparison_Noageratingsfound3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Comparison_Noageratingsfound3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_comparison_noageratingsfound3(inputs)
	if (locale === "ms") return ms_components_comparison_noageratingsfound3(inputs)
	if (locale === "da") return da_components_comparison_noageratingsfound3(inputs)
	if (locale === "de") return de_components_comparison_noageratingsfound3(inputs)
	if (locale === "en-US") return en_us2_components_comparison_noageratingsfound3(inputs)
	if (locale === "es-ES") return es_es2_components_comparison_noageratingsfound3(inputs)
	if (locale === "es-MX") return es_mx2_components_comparison_noageratingsfound3(inputs)
	if (locale === "fil") return fil_components_comparison_noageratingsfound3(inputs)
	if (locale === "fr") return fr_components_comparison_noageratingsfound3(inputs)
	if (locale === "it") return it_components_comparison_noageratingsfound3(inputs)
	if (locale === "hu") return hu_components_comparison_noageratingsfound3(inputs)
	if (locale === "nl") return nl_components_comparison_noageratingsfound3(inputs)
	if (locale === "no") return no_components_comparison_noageratingsfound3(inputs)
	if (locale === "pl") return pl_components_comparison_noageratingsfound3(inputs)
	if (locale === "pt-BR") return pt_br2_components_comparison_noageratingsfound3(inputs)
	if (locale === "pt") return pt_components_comparison_noageratingsfound3(inputs)
	if (locale === "ro") return ro_components_comparison_noageratingsfound3(inputs)
	if (locale === "fi") return fi_components_comparison_noageratingsfound3(inputs)
	if (locale === "sv") return sv_components_comparison_noageratingsfound3(inputs)
	if (locale === "vi") return vi_components_comparison_noageratingsfound3(inputs)
	if (locale === "tr") return tr_components_comparison_noageratingsfound3(inputs)
	if (locale === "cs") return cs_components_comparison_noageratingsfound3(inputs)
	if (locale === "bg") return bg_components_comparison_noageratingsfound3(inputs)
	if (locale === "ru") return ru_components_comparison_noageratingsfound3(inputs)
	if (locale === "uk") return uk_components_comparison_noageratingsfound3(inputs)
	if (locale === "ar") return ar_components_comparison_noageratingsfound3(inputs)
	if (locale === "hi") return hi_components_comparison_noageratingsfound3(inputs)
	if (locale === "th") return th_components_comparison_noageratingsfound3(inputs)
	if (locale === "ja") return ja_components_comparison_noageratingsfound3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_comparison_noageratingsfound3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_comparison_noageratingsfound3(inputs)
	return ko_components_comparison_noageratingsfound3(inputs)
});
export { components_comparison_noageratingsfound3 as "components.comparison.noAgeRatingsFound" }